import React, { useEffect, useRef, useState } from 'react';
import { Modal, ProgressBar, Spinner } from 'react-bootstrap';
import { ClearBtn, SearchBtn } from '../../Buttons/Buttons';
import { toast } from 'react-toastify';
import * as HeaderAuthentication from '../../HeaderAuthentication';
import { useDispatch } from 'react-redux';
import { loadProgress, loadUploadCsv } from '../../redux/action';
import { Label } from 'reactstrap';
import Draggable from 'react-draggable';

const UploadCSVModal = ({ show, handleClose }) => {
    let dispatch = useDispatch();
    const dragRef = React.useRef(null);
    const [dragActive, setDragActive] = useState(false);

    const fileInputRef = useRef(null);
    const [file, setFile] = useState(null);

    const [progress, setProgress] = useState(0);
    const [verientColor, setVerientColor] = useState("");
    const [uploadStatus, setUploadStatus] = useState(false);
    const [isStarted, setIsStarted] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);
    const [isError, setIsError] = useState(false);
    const [fileName, setFileName] = useState("");

    const handleFileChange = (e) => {
        const new_file = e.target.files[0]
        if(new_file){
            console.log(new_file)
            setFileName(new_file.name)
            setFile(new_file);
        }
    };

    const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      fileInputRef.current.files = e.dataTransfer.files; 
      handleFileChange({ target: fileInputRef.current });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };


    // #region submit function
    const submitCSVFile = (e) => {
        e.preventDefault();
        
        if(file == null){
            toast.error("Please select the file");
            return;
        }

        setUploadStatus(true)
        setIsError(false);
        setIsStarted(false);
        dispatch(loadProgress());

        const requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postAuthForFile,
            // body: file,
            body: new Blob([file], { type: "text/csv" }),
        };
        dispatch(loadUploadCsv(requestOption, close_Model, setIsCompleted, setIsError))
        
    }
    // #endrgeion

    useEffect(() => {
        let interval;
      
        if (uploadStatus && !isCompleted && !isError) {
          interval = setInterval(() => {
            dispatch(loadProgress(isStarted, setIsStarted, setProgress, setVerientColor));
          }, 3000);
        }
      
        // Cleanup function: stop polling when isCompleted is true or component unmounts
        return () => {
          if (interval) clearInterval(interval);
        };
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [uploadStatus, isCompleted, isError]);

    const close_Model = () => {
        fileInputRef.current.value = null;
        setFileName("");
        setFile(null);
        handleClose()
    }

    const upload_new_filw = () => {
        fileInputRef.current.value = null;
        setFileName("");
        setFile(null);
        setUploadStatus(false);
        setProgress(0);
        setVerientColor("");
        setIsStarted(false);
        setIsCompleted(false);
    }

    return (
        <Modal
        show={show}
        onHide={handleClose}
        className="upload-modal"
        dialogClassName="modal-80w"
        backdrop="static"
        keyboard={false}
        centered
        >
      <Draggable handle=".modal-header" nodeRef={dragRef}>
        <div ref={dragRef}>
          <div className="">
            <div className="modal-content sub_modal-content">
              <Modal.Header closeButton className="cursor-move">
                <Modal.Title className='upload-header'>Upload CSV File</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <div
                  className={`drop-zone ${dragActive ? "active" : ""}`}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current.click()}
                  disabled
                  style={{
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                    padding: "20px",
                    textAlign: "center",
                    cursor: "pointer",
                    alignContent: "center",
                    justifyItems: "center",
                    pointerEvents: uploadStatus ? "none" : "auto",
                    opacity: uploadStatus ? 0.6 : 1
                  }}
                >
                  <p><b>{fileName}</b></p>
                  <div className='copy-icon-section' style={(uploadStatus && !isCompleted) ? { animation: "spin 5s infinite linear" } : undefined}>
                    <i class="fa-solid fa-file" style={(uploadStatus && !isCompleted) ? { animation: "spin 5s infinite reverse linear" } : undefined}></i>
                    <p className='percent-text' style={(uploadStatus && !isCompleted) ? { animation: "spin 5s infinite reverse linear" } : undefined}>{uploadStatus && !isCompleted && `${progress}%`}</p>
                  </div>
                  <p>{dragActive ? "Drop your CSV file here" : "Drag & drop CSV here"}</p>
                  <h6>Or</h6>
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                    className="form-control"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                  />
                  
                  <SearchBtn btnName='Click to browse'/>
                  <Label className='m-0 note-label'>* Please select .csv file to upload contacts.</Label>
                </div>
              </Modal.Body>

              {!uploadStatus ? (
                <Modal.Footer>
                  <ClearBtn btnName='Cancel' onClickEffect={handleClose} />
                  <SearchBtn btnName='Submit' onClickEffect={submitCSVFile} />
                </Modal.Footer>
              ) : (
                <Modal.Footer className='d-block' style={{ textAlign: "center" }}>
                  {!isError ? (
                    <>
                      {!isCompleted ? (
                        <>
                          {!isStarted ? (
                            <div>
                              <Spinner animation="border" variant="primary" />
                              <h6 className='progress_wait_text pt-2'>Wait for a while, File is processing...!</h6>
                            </div>
                          ) : (
                            <div>
                              <ProgressBar animated now={progress} label={`${progress}%`} variant={verientColor} style={{ height: '10px' }} />
                              <h6 className='progress_waiting_text pt-2'>Wait till it complete...!</h6>
                            </div>
                          )}
                        </>
                      ) : (
                        <div>
                          <div className='d-flex align-items-center justify-content-center'>
                            <h6 className='file_status m-0'>File processed successfully.</h6>&nbsp;&nbsp;
                            <SearchBtn btnName='Upload New' onClickEffect={upload_new_filw} />
                          </div>
                          <div className='d-flex align-items-center justify-content-center pt-2'>
                            <h6>Do you want to close the modal? <span className='close-text' onClick={close_Model}>Click here.</span></h6>
                          </div>
                        </div>
                      )}
                    </>
                  ) : (
                    <div className='d-flex align-items-center justify-content-center'>
                      <h6 className='progress_wait_text m-0'>Something went wrong. File not processed. Try again...!</h6>&nbsp;&nbsp;
                      <SearchBtn btnName='Try Again' onClickEffect={submitCSVFile} />
                    </div>
                  )}
                </Modal.Footer>
              )}
            </div>
          </div>
        </div>
      </Draggable>
    </Modal>
  );
};

export default UploadCSVModal;
